import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PasswordForgottenPage } from './password-forgotten';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    PasswordForgottenPage,
  ],
  imports: [
    IonicPageModule.forChild(PasswordForgottenPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class PasswordForgottenPageModule {}



// WEBPACK FOOTER //
// ./src/pages/password-forgotten/password-forgotten.module.ts